/* Wuschelherz: aus snippets/wh-quick-view.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
    (() => {
      if (window.whQuick) return;
      const root = document.getElementById('WhQuickView');
      if (!root) return;
      const frame = root.querySelector('.wh-qv__frame');
      const titleEl = root.querySelector('#WhQuickViewTitle');
      const fullLink = root.querySelector('[data-wh-qv-full]');
      const stepEl = root.querySelector('[data-wh-qv-step]');
      const toast = root.querySelector('[data-wh-qv-toast]');
      const QUEUE = 'wh-quick-queue';
      let lastFocus = null;
      let reopenDrawer = false;
      let changed = false;
      let toastTimer;

      const readQueue = () => { try { return JSON.parse(sessionStorage.getItem(QUEUE) || '{"items":[],"total":0}'); } catch (e) { return { items: [], total: 0 }; } };
      const writeQueue = (q) => { try { if (q && q.items.length) sessionStorage.setItem(QUEUE, JSON.stringify(q)); else sessionStorage.removeItem(QUEUE); } catch (e) {} };

      const quickUrl = (href) => {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('view', 'quick');
        url.searchParams.set('wh_auto', '1');
        return url.pathname + url.search;
      };
      const plainUrl = (href) => {
        const url = new URL(href, window.location.origin);
        url.searchParams.delete('view');
        url.searchParams.delete('wh_auto');
        return url.pathname + url.search;
      };

      const showToast = (text) => {
        toast.textContent = text; toast.hidden = false;
        clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 2600);
      };

      const updateStep = () => {
        const q = readQueue();
        if (q.total > 1) {
          stepEl.textContent = 'Bild ' + (q.total - q.items.length) + ' von ' + q.total;
          stepEl.hidden = false;
        } else {
          stepEl.hidden = true;
        }
      };

      const load = (href, title) => {
        root.classList.remove('is-loaded');
        titleEl.textContent = title || 'Design ansehen';
        fullLink.href = plainUrl(href);
        frame.src = quickUrl(href);
        updateStep();
        if (typeof watch === 'function') watch();
      };

      const open = (href, title) => {
        // Runde 4: auf dem Handy kein iframe (Safari lehnte die Einbettung teils ab), die Produktseite öffnet sich direkt
        if (window.matchMedia('(max-width: 989px)').matches) { window.location.href = plainUrl(href); return; }
        lastFocus = document.activeElement;
        changed = false;
        // Offene Schubladen (z. B. Warenkorb) schließen: deren Fokusfalle würde Eingaben im Overlay verhindern.
        // Nach „In den Warenkorb“ (oder beim Schließen, wenn er offen war) öffnet sich der Warenkorb wieder.
        reopenDrawer = !!document.querySelector('cart-drawer[open]');
        document.querySelectorAll('cart-drawer[open], drawer-element[open], menu-drawer[open]').forEach((d) => { try { d.hide(); } catch (e) {} });
        try { if (window.theme && theme.a11y && theme.a11y.removeTrapFocus) theme.a11y.removeTrapFocus(); } catch (e) {}
        load(href, title);
        root.hidden = false;
        document.documentElement.classList.add('wh-qv-open');
        requestAnimationFrame(() => root.classList.add('is-open'));
        setTimeout(() => root.classList.add('is-open'), 30);
        root.querySelector('.wh-qv__close').focus({ preventScroll: true });
      };

      const refreshCart = async (openDrawer) => {
        try {
          const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'wh-quick', cart });
          }
        } catch (e) {}
        if (/^\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        } else if (document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: !!openDrawer } }));
        }
      };

      const close = (opts = {}) => {
        if (root.hidden) return;
        root.classList.remove('is-open');
        document.documentElement.classList.remove('wh-qv-open');
        setTimeout(() => { root.hidden = true; frame.src = 'about:blank'; root.classList.remove('is-loaded'); }, 220);
        if (!opts.keepQueue) writeQueue(null);
        if (changed || opts.openCart) refreshCart(opts.openCart || reopenDrawer);
        else if (reopenDrawer) { const d = document.querySelector('cart-drawer'); try { if (d) d.show(); } catch (e) {} }
        if (lastFocus && lastFocus.focus && !opts.openCart) lastFocus.focus({ preventScroll: true });
      };

      const onAdded = () => {
        changed = true;
        const q = readQueue();
        if (q.items.length) {
          const next = q.items.shift();
          writeQueue(q);
          showToast('Liegt im Warenkorb. Weiter mit dem nächsten Bild.');
          if (!/^\/cart\/?$/.test(window.location.pathname)) refreshCart(false);
          setTimeout(() => load(next.url, next.title), 900);
          return;
        }
        showToast('Liegt im Warenkorb');
        setTimeout(() => close({ openCart: true }), 700);
      };

      window.addEventListener('message', (event) => {
        if (event.origin !== window.location.origin || !event.data || event.data.source !== 'wh-quick') return;
        if (event.source !== frame.contentWindow) return;
        if (event.data.type === 'added') onAdded();
        if (event.data.type === 'ready') root.classList.add('is-loaded');
      });

      // Rückfall: Lässt der Browser die Einbettung nicht zu (z. B. Passwortschutz oder Vorschau-Sitzung leitet die
      // Anfrage auf eine andere Domain um), öffnet sich die Produktseite ganz normal.
      const fallback = () => {
        if (root.hidden) return;
        writeQueue(null);
        window.location.href = fullLink.getAttribute('href');
      };
      let watchdog;
      const watch = () => { clearTimeout(watchdog); watchdog = setTimeout(() => { if (!root.classList.contains('is-loaded')) fallback(); }, 15000); };

      frame.addEventListener('load', () => {
        if (root.hidden) return;
        let path = '', search = '';
        try { path = frame.contentWindow.location.pathname; search = frame.contentWindow.location.search; } catch (e) { fallback(); return; }
        if (!path || path === 'blank') { fallback(); return; }
        if (/^\/cart\/?$/.test(path)) { onAdded(); return; }
        // Per Skript auf eine normale Produktseite gewechselt (z. B. Format-App): als Overlay-Ansicht neu laden
        if (/^\/products\//.test(path) && !/[?&]view=quick/.test(search)) { frame.src = quickUrl(path + search); return; }
        if (/^\/products\//.test(path)) fullLink.href = plainUrl(path + search);
        root.classList.add('is-loaded');
      });

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-wh-qv-close]')) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !root.hidden) close();
      });

      // Auslöser: eigene Karten (data-wh-quick) und Concepts Quick-View-Buttons
      document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const own = event.target.closest('a[data-wh-quick]');
        if (own) {
          event.preventDefault();
          writeQueue(null);
          open(own.href, own.getAttribute('data-wh-quick-title') || own.textContent.trim());
          return;
        }
        const concept = event.target.closest('[aria-controls^="Quickview-"]');
        if (concept) {
          const qv = document.getElementById(concept.getAttribute('aria-controls'));
          const url = qv && qv.getAttribute('data-product-url');
          if (!url) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          writeQueue(null);
          open(url, '');
        }
      }, true);

      window.whQuick = {
        open,
        close,
        // Mehrere Designs nacheinander gestalten (Bundle-Baukasten): items = [{ url, title }]
        queue(items) {
          if (!items || !items.length) return;
          // Seit Runde 4 läuft das Bundle über wh-bundle-flow (übersteht Seitenwechsel)
          if (window.whBundle) { window.whBundle.start(items); return; }
          const list = items.slice();
          const first = list.shift();
          writeQueue({ items: list, total: items.length });
          open(first.url, first.title);
        }
      };
    })();
  
